import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'fileSizeToBytes',
    standalone: true
})
export class FileSizeToBytesPipe implements PipeTransform {
    transform(size: string): number {
        if (!size || typeof size !== 'string') return 0;

        const regex = /^\s*([\d.]+)\s*(B|KB|MB|GB|TB)?\s*$/i;
        const match = size.match(regex);

        if (!match) return 0;

        const value = parseFloat(match[1]);
        const unit = match[2]?.toUpperCase() || 'B';

        const units = ['B', 'KB', 'MB', 'GB', 'TB'];
        const index = units.indexOf(unit);

        if (index === -1) return 0;

        return Math.round(value * Math.pow(1024, index));
    }
}
